import FaturamentoService from "@/services/FaturamentoService";

export const faturamento = {
  namespaced: true,
  state: {
    faturamento: {},
  },
  actions: {
    getFaturamento({ commit }, payload) {
      return FaturamentoService.GetFaturamento(payload).then(
        (faturamento) => {
          return Promise.resolve(faturamento);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postFaturamento({ commit }, payload) {
      return FaturamentoService.PostFaturamento(payload).then(
        (faturamento) => {
          return Promise.resolve(faturamento);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putFaturamento({ commit }, payload) {
      return FaturamentoService.PutFaturamento(payload).then(
        (faturamento) => {
          return Promise.resolve(faturamento);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteFaturamento({ commit }, payload) {
      return FaturamentoService.DeleteFaturamento(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getFaturamentoOData({ commit }, payload) {
      return FaturamentoService.GetFaturamentoOData(payload).then(
        (faturamento) => {
          return Promise.resolve(faturamento);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    imprimir({ commit }, payload) {
      return FaturamentoService.Imprimir(payload).then(
        (faturamento) => {
          return Promise.resolve(faturamento);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default faturamento;
